/**
 * Checks if value is an empty object, collection, map, or set.
 *
 * @param {any} value - The value to check.
 * @return {Boolean} True if value is empty, else False.
 */
export const isEmpty = (value): boolean =>
  value ? [Object, Array].includes(value.constructor) && !Object.entries(value).length : true;
